import angular from "angular";
import AuthorizeCard from "./AuthorizeCard.vue";
import Vue from "vue";
import "ngVue";

export default angular
  .module("directives.authorizecard", [])
  .directive("dcAuthorizeCard", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(
        Vue.component("DcAuthorizeCard", AuthorizeCard),
      );
    },
  ]);

